import React from "react";
import { Grid } from "@material-ui/core";
import { View } from "@/components/view/view";
import { useLocation } from "react-router-dom";
import MarketingViewSeenOn from "./marketingViewSeenOn";
import styles from "./styles";
import clsx from "clsx";
import { useResponsiveHelper } from "@/contexts/responsiveContext";
import { Helmet } from "react-helmet-async";
import { DEMO_SCHEDULE_ROUTE } from "@/components/router";
import { useDialogFrameDimensions } from "./hooks/useDialogFrameDimensions";

interface ComponentProps {
  children: React.ReactNode;
  documentTitle?: string;
  hideMarketingView?: boolean;
  gap?: number;
}

const DemoSignupLayout = ({ children, documentTitle, hideMarketingView, gap }: ComponentProps) => {
  const classes = styles();
  const location = useLocation();
  const { isTabletOrMobile } = useResponsiveHelper();
  const { frameMaxWidth, frameMaxHeight } = useDialogFrameDimensions();

  const renderMarketingView = () => {
    if (location.pathname.indexOf(DEMO_SCHEDULE_ROUTE) > -1 || hideMarketingView) {
      return null;
    }
    return <MarketingViewSeenOn />;
  };

  const renderLayout = () =>
    isTabletOrMobile ? (
      <View height={"100%"} alignItems={"center"} overflow={"scroll"} width={"100%"}>
        <View width={"100%"} alignItems={"center"} maxWidth={frameMaxWidth} flex={1}>
          {children}
          {renderMarketingView()}
        </View>
      </View>
    ) : (
      <div style={{ height: "100%", overflow: "hidden" }}>
        <Grid container justify={"center"} alignItems={"center"} style={{ height: "100%" }}>
          <View
            overflow={"scroll"}
            gap={gap ?? 40}
            paddingBottom={40}
            backgroundColor={"white"}
            noWrap
            borderRadius={20}
            maxHeight={frameMaxHeight < window.innerHeight ? frameMaxHeight : window.innerHeight - 40}
            width={frameMaxWidth}
            className={clsx([classes.demoSignupLayout, "slide-in-right"])}
          >
            {children}
            {renderMarketingView()}
          </View>
        </Grid>
      </div>
    );

  return (
    <div className="h-full w-full overflow-hidden bg-background-neutral2 md:bg-inherit">
      {documentTitle && (
        <Helmet>
          <title>{documentTitle}</title>
        </Helmet>
      )}
      {renderLayout()}
    </div>
  );
};

export default DemoSignupLayout;
